export default "__VITE_ASSET__TiJiSf6x__"